import { useEffect, useState } from 'react';
import { getSelectedDate } from '../../helpers';

const useDateFromUrl = (fallbackDate) => {
    const [currentDay, setCurrentDay] = useState(getSelectedDate() ?? fallbackDate);

    useEffect(() => {
        const syncDateFromUrl = () => {
            const date = getSelectedDate();
            if (date) setCurrentDay(date);
        };

        window.addEventListener('popstate', syncDateFromUrl);
        window.addEventListener('diary-date-change', syncDateFromUrl);

        return () => {
            window.removeEventListener('popstate', syncDateFromUrl);
            window.removeEventListener('diary-date-change', syncDateFromUrl);
        };
    }, []);

    return currentDay;
};

export default useDateFromUrl;
